import axios from "axios";

const BASE_PRECARGA_URL = "https://gopal-backend-fork-staging-970334009292.southamerica-east1.run.app/";
// const BASE_PRECARGA_URL = "http://localhost:8002/";
// const BASE_PRECARGA_URL = "https://api.thepeachlabs.com/"

const PrecargaApi = axios.create({
  baseURL: BASE_PRECARGA_URL + "precarga/v1/admin/",
});

const LegacyAdminApi = axios.create({
  baseURL: BASE_PRECARGA_URL + "precarga/v1/legacy-admin/",
});

// Add token to all requests
PrecargaApi.interceptors.request.use((config) => {
  const userString = localStorage.getItem("user");
  if (userString) {
    try {
      const user = JSON.parse(userString);
      if (user?.token) {
        // Use Bearer token authentication
        config.headers["Authorization"] = `Bearer ${user.token}`;
      }
    } catch (error) {
      console.error("Error parsing user from localStorage", error);
    }
  }
  return config;
});

// Add token to legacy admin requests using X-Admin-Token header
LegacyAdminApi.interceptors.request.use((config) => {
  const userString = localStorage.getItem("user");
  if (userString) {
    try {
      const user = JSON.parse(userString);
      if (user?.token) {
        config.headers["X-Admin-Token"] = user.token;
      }
    } catch (error) {
      console.error("Error parsing user from localStorage", error);
    }
  }
  return config;
});

export async function precargaGet(endpoint, params) {
  try {
    const response = await PrecargaApi.get(endpoint, { params });
    return response.data;
  } catch (error) {
    console.error("precargaGet error", error);
    if (error.response?.data) throw error.response.data;
    throw error;
  }
}

export async function precargaPost(endpoint, data) {
  try {
    const response = await PrecargaApi.post(endpoint, data);
    return response.data;
  } catch (error) {
    console.error("precargaPost error", error);
    if (error.response?.data) throw error.response.data;
    throw error;
  }
}

export async function precargaPatch(endpoint, data) {
  try {
    const response = await PrecargaApi.patch(endpoint, data);
    return response.data;
  } catch (error) {
    console.error("precargaPatch error", error);
    if (error.response?.data) throw error.response.data;
    throw error;
  }
}

// Legacy Admin API functions
export async function legacyAdminGet(endpoint, params) {
  try {
    const response = await LegacyAdminApi.get(endpoint, { params });
    return response.data;
  } catch (error) {
    console.error("legacyAdminGet error", error);
    if (error.response?.data) throw error.response.data;
    throw error;
  }
}

export default PrecargaApi;
